<div class="hrsMnto">
  <div class="hrsMnto__tittle">
    <i class="if2rt-clock"></i>
    <span>CONTROL ASIGNACIÓN DE HORAS</span>
  </div>
  <div class="hrsMnto__content">
    <div class="hrsMnto__content__item">
      <div class="center">{{ this.controllerUsed?.hourscontrollerplan | number:'1.1-1' }}</div>
      <div class="hrsMnto__content__item__tittle">Hrs. asignadas</div>
    </div>
    <div class="hrsMnto__content__item">
      <div class="center">{{  this.controllerUsed?.hoursflymonth | number:'1.1-1'}}</div>
      <div class="hrsMnto__content__item__tittle">Hrs. voladas</div>
    </div>
    <div class="hrsMnto__content__item">
      <div class="center">{{ (this.controllerUsed?.hourscontrollerplan - this.controllerUsed?.hoursflymonth) | number:'1.1-1'}}</div>
      <div class="hrsMnto__content__item__tittle">Hrs. disponibles</div>
    </div>
  </div>
  <div class="hrsMnto__hrsFlying">
    <span>HORAS VOLADAS HOY</span>
    <span>{{ this.controllerUsed?.hourstoday | number:'1.1-1' }}</span>
  </div>
</div>